import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IpProfilesComponent} from './ip-profiles.component';
import {ColumnsFilterModule} from '../../components/columns-filter/columns-filter.module';
import { IpProfilesSummaryComponent } from './ip-profiles-summary/ip-profiles-summary.component';
import { IpProfileDialogComponent } from './ip-profile-dialog/ip-profile-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {IpProfilesResolver} from './ip-profiles-resolver';
import {FlexModule} from '@angular/flex-layout';
import { DefaultIpProfilePipe } from './default-ip-profile.pipe';
import {LayoutModule} from '../../components/layout/layout.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';

@NgModule({
  declarations: [
    IpProfilesComponent,
    IpProfilesSummaryComponent,
    IpProfileDialogComponent,
    DefaultIpProfilePipe
  ],
    imports: [
        CommonModule,
        ColumnsFilterModule,
        DialogModule,
        FormsModule,
        FlexModule,
        LayoutModule,
        MaterialModule,
        ActionBarModule,
        ArmTableModule,
        ClientFilterModule
    ],
  providers: [
    IpProfilesResolver
  ]
})
export class IpProfilesModule { }
